export const ENV = process.env.REACT_APP_ENV;

export const FORM_HANDLER_API_URL = ENV === 'dev' ? 'https://listings.realweb.com/wp-json/realweb-listings-addons_api/v1/entries/' : '/wp-json/realweb-listings-addons_api/v1/entries/';
